'use strict';

var _objectSpread = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread2");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var parseChunkerString = function parseChunkerString(chunker) {
  if (!chunker) {
    return {
      chunker: 'fixed'
    };
  } else if (chunker.startsWith('size-')) {
    var sizeStr = chunker.split('-')[1];
    var size = parseInt(sizeStr);

    if (isNaN(size)) {
      throw new Error('Chunker parameter size must be an integer');
    }

    return {
      chunker: 'fixed',
      maxChunkSize: size
    };
  } else if (chunker.startsWith('rabin')) {
    return _objectSpread({
      chunker: 'rabin'
    }, parseRabinString(chunker));
  } else {
    throw new Error("Unrecognized chunker option: ".concat(chunker));
  }
};

var parseRabinString = function parseRabinString(chunker) {
  var options = {};
  var parts = chunker.split('-');

  switch (parts.length) {
    case 1:
      options.avgChunkSize = 262144;
      break;

    case 2:
      options.avgChunkSize = parseChunkSize(parts[1], 'avg');
      break;

    case 4:
      options.minChunkSize = parseChunkSize(parts[1], 'min');
      options.avgChunkSize = parseChunkSize(parts[2], 'avg');
      options.maxChunkSize = parseChunkSize(parts[3], 'max');
      break;

    default:
      throw new Error('Incorrect chunker format (expected "rabin" "rabin-[avg]" or "rabin-[min]-[avg]-[max]"');
  }

  return options;
};

var parseChunkSize = function parseChunkSize(str, name) {
  var size = parseInt(str);

  if (isNaN(size)) {
    throw new Error("Chunker parameter ".concat(name, " must be an integer"));
  }

  return size;
};

exports.parseChunkSize = parseChunkSize;
exports.parseChunkerString = parseChunkerString;
exports.parseRabinString = parseRabinString;